import { Box } from "@mui/system";
import PieChart from "../pie";
import CustomLinearProgress from "../progress/linearProgress";
import React from "react";
import { MyPieDashConfig } from "../pie/types";

const PieAndProgress: React.FC<MyPieDashConfig> = (props) => {
  const { data, colors, colorsByKey } = props;
  const dataKeys = Object.keys(data);
  const styles = {
    containerBox: {
      display: "flex",
      flexDirection: { xs: "column", lg: "row" },
      gap: 3,
      width: "100%",
      paddingX: 3,
    },
    boxPie: {
      display: "flex",
      flexDirection: { xs: "column", lg: "row" },
      alignItems: "center",
      width: { xs: "100%", lg: "100%" },
      maxWidth: { xs: "100%", lg: "50%" },
      height: 400,
    },
    boxDataGridAndProgress: {
      display: "flex",
      alignItems: "center",
      flexDirection: "column",
      height: "100%",
      width: "100%",
      backgroundColor: "background.card",
      borderRadius: 2,
      padding: 3,
    },
  };

  // const valueTotal = dataKeys.reduce((acc: number, item) => {
  //   return acc + Number(data[item]), 0;
  // }, 0);

  return (
    <Box sx={styles.containerBox}>
      <Box sx={styles.boxPie}>
        <PieChart {...props} />
      </Box>
      <Box sx={styles.boxDataGridAndProgress}>
        {/* <CustomLinearProgress
          data={data}
          valueTotal={valueTotal}
          colors={colors}
          colorsByKey={colorsByKey}
        /> */}
      </Box>
    </Box>
  );
};

export default PieAndProgress;
